"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RAG_DEFAULT_SETUP = void 0;
exports.RAG_DEFAULT_SETUP = {
    chunking: {
        chunkSize: 650,
        chunkOverlap: 150,
        separators: ['\n\n', '\n']
    },
    search: {
        defaultMaxResults: 3,
        defaultSimilarityThreshold: 0.3,
        maxResults: 6
    }
};
